import axios from 'axios';

const TicketService = {
  async getTickets(borrowerEmail) {
    const response = await axios.get(`/ticket?email=${borrowerEmail}`);

    return response.data;
  },

  async getTicket(ticketId) {
    const response = await axios.get(`/ticket/${ticketId}`);

    return response.data;
  },

  async getTicketConversations(ticketId) {
    const response = await axios.get(`/ticket/${ticketId}/conversations`);

    return response.data;
  },
};

export default TicketService;
